import { useTheme } from "@mui/material";
import React from "react";
import DatabaseSvg from "../../../components/svgComponents/DatabaseSvg";
import HoldersSvg from "../../../components/svgComponents/HoldersSvg";
import HumiditySvg from "../../../components/svgComponents/HumiditySvg";
import MonitoringSvg from "../../../components/svgComponents/MonitoringSvg";
import PathItem from "../PathItem/PathItem";
import SectionHeader from "../SectionHeader/SectionHeader";

const PathToSuccess = ({
  fdv,
  holdersCount,
  liquidity,
  totalSupply,
  selectedTokenOneName,
  selectedTokenTwoName,
}) => {
  const theme = useTheme();

  const handleSwapClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const chooseTokenName = () => {
    if (selectedTokenOneName === "XBR" || selectedTokenTwoName === "XBR") {
      return "XBR";
    }
    if (selectedTokenOneName === "TBA" || selectedTokenTwoName === "TBA") {
      return "TBA";
    }

    return "Other";
  };

  return (
    <div className="w-full rounded-3xl md:bg-white dark:bg-darkCardBg md:shadow-smallShadow pt-6 pb-8">
      <SectionHeader
        sectionTitle={"Swap With Ease"}
        sectionDescription={
          "Trade XBR and TBA for USDT with no hassle on our seamless platform."
        }
      />
      <div className="grid lg:grid-cols-2 gap-3 border-b border-lightGrayBlue dark:border-darkSlateBlue px-6 md:px-8 pt-3 pb-4">
        <PathItem
          itemTitle={"Market Cap"}
          itemValue={fdv && `$${fdv}`}
          itemIcon={<MonitoringSvg />}
        />
        <PathItem
          itemTitle={"XBR Holders"}
          itemValue={holdersCount}
          itemIcon={<HoldersSvg />}
        />
        <PathItem
          itemTitle={"Liquidity"}
          itemValue={liquidity && `$${liquidity}`}
          itemIcon={<HumiditySvg />}
        />
        <PathItem
          itemTitle={"Circulating supply"}
          itemValue={totalSupply && `${totalSupply} ${chooseTokenName()}`}
          itemIcon={<DatabaseSvg />}
        />
      </div>
      <footer className="pt-6 px-6 md:px-8 w-full flex justify-center">
        <button
          type="button"
          onClick={handleSwapClick}
          className="w-full h-14 text-base leading-6 font-medium rounded-lg 
          border text-white border-white shadow-swapButton transition-colors 
          duration-300 bg-deepBlue hover:bg-vividBlueViolet flex items-center 
          justify-center active:bg-[#1E31FF]"
        >
          Swap Now
        </button>
      </footer>
    </div>
  );
};

export default PathToSuccess;
